<template>
  <b-form @submit.prevent="submit()">
    <div class="justify-content-md-center customer-info-form boxes">
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="first_name" v-if="isIE">First Name*</label>
          <b-form-group label="" label-for="first_name">
            <div data-for="first_name" class="placeholder-label">First Name*</div>
            <b-form-input id="first_name" type="text" v-model.trim="addressData.first_name" :placeholder="placeholders.first_name" class="customer"></b-form-input>
            <div v-if="fieldErrors.first_name" class="text-danger input-error text-right pr-2">
              <small>{{ fieldErrors.first_name }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="last_name" v-if="isIE">Last Name*</label>
          <b-form-group label="" label-for="last_name">
            <div data-for="last_name" class="placeholder-label">Last Name*</div>
            <b-form-input id="last_name" type="text" v-model.trim="addressData.last_name" :placeholder="placeholders.last_name" class="customer"></b-form-input>
            <div v-if="fieldErrors.last_name" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.last_name }}</small>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="address1" v-if="isIE">Street Address*</label>
          <b-form-group label="" label-for="address1">
            <div data-for="address1" class="placeholder-label">Street Address*</div>
            <b-form-input id="address1" type="text" v-model.trim="addressData.address1" :placeholder="placeholders.address1" class="customer"></b-form-input>
            <div v-if="fieldErrors.address1" class="text-danger input-error text-right pr-2">
              <small>{{ fieldErrors.address1 }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="address2" v-if="isIE">Street Address 2</label>
          <b-form-group label="" label-for="address2">
            <div data-for="address2" class="placeholder-label">Street Address 2</div>
            <b-form-input id="address2" type="text" v-model.trim="addressData.address2" :placeholder="placeholders.address2" class="customer"></b-form-input>
            <div v-if="fieldErrors.address2" class="text-danger input-error text-right pr-2">
              <small>{{ fieldErrors.address2 }}</small>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="city" v-if="isIE">City*</label>
          <b-form-group label="" label-for="city">
            <div data-for="city" class="placeholder-label">City*</div>
            <b-form-input id="city" type="text" v-model.trim="addressData.city" :placeholder="placeholders.city" class="customer"></b-form-input>
            <div v-if="fieldErrors.city" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.city }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="state" v-if="isIE">State*</label>
          <b-form-group label="" label-for="state">
            <div data-for="state" class="placeholder-label">State*</div>
            <b-form-select id="state" v-model="addressData.state" :options="getStates(addressData.country)" :placeholder="placeholders.state" class="customer select"></b-form-select>
            <div v-if="fieldErrors.state" class="text-danger input-error text-right pr-1">
                <small>{{ fieldErrors.state }}</small>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="zip" v-if="isIE">Zip Code*</label>
          <b-form-group label="" label-for="zip">
            <div data-for="zip" class="placeholder-label">Zip Code*</div>
            <b-form-input id="zip" maxlength="5" type="text" v-model.trim="addressData.zip" :placeholder="placeholders.zip" class="customer"></b-form-input>
            <div v-if="fieldErrors.zip" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.zip }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="country" v-if="isIE">Country</label>
          <b-form-group label="" label-for="country">
            <div data-for="country" class="placeholder-label">Country</div>
            <b-form-input :disabled="true" id="country" type="text" value="United States" class="customer"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <input id="country" type="hidden" v-model="addressData.country" />
    <b-row v-if="input" class="justify-content-md-center boxes">
      <b-col md="6" lg="6" class="pl-sm-0 pr-sm-0">
        <b-row class="justify-content-md-center boxes customer-verify-btn customer-verify">
          <b-col md="6" cols="6">
            <b-button block @click="$emit('goBack')" class="btn-outline-success btn-back" variant="outline-success">Back</b-button>
          </b-col>
          <b-col md="6" cols="6">
            <b-button block type="submit" class="btn btn-default btn-account" variant="primary">
            <span v-html="input.formatted_label"></span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapState } from 'vuex'
import { Regions } from '@/constants'

export default {
  name: 'CustomerInfoForm',
  props: {
    placeholders: Object,
    addressData: Object,
    input: Object,
    responseErrors: Object
  },
  data: function() {
    return {
      fieldErrors: {}
    }
  },
  watch: {
    'addressData': {
      handler: function(val) {
        this.fieldErrors = {}
        this.validateInformation()
      },
      deep: true
    },
    'responseErrors': {
      handler: function(val) {
        let errors = {...this.fieldErrors}
        this.fieldErrors = {}

        Object.keys(val).forEach(key => {
          if (val[key]) {
            errors[key.replace('ship_', '')] = val[key][0]
          }
        })
        this.fieldErrors = errors
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['session', 'isIE', 'campaign'])

  },
  methods: {
    submit: function() {
      if (this.validateInformation()) {
        this.$emit('submit', this.addressData)
      }
    },
    validateInformation: function() {
      let requiredFields = [
        'first_name',
        'last_name',
        'address1',
        'city',
        'state',
        'zip'
      ]
      let valid = true
      let existingFieldsErrors = {...this.fieldErrors}
      requiredFields.forEach(field => {
        let value = this.addressData[field]
        existingFieldsErrors[field] = null
        if (!value || value.length < 1) {
          existingFieldsErrors[field] = 'This field is required.'
          valid = false
        }
        if (field === 'zip' && value.length < 5) {
          existingFieldsErrors[field] = 'Invalid Zip Code'
        }
      })
      this.fieldErrors = existingFieldsErrors
      return valid
    },
    getStates(country = Regions.US) {
      let states = [{value: null, text: 'State', disabled: true}]
      Regions[country].forEach(state => {
        states.push({...state,
          disabled: this.campaign.blacklisted_states && this.campaign.blacklisted_states.length > 0 &&
            this.campaign.blacklisted_states.indexOf(state.value) > -1})
      })

      return states
    }
  }

}
</script>
